import { getFirestore, doc, getDoc, collection, addDoc, serverTimestamp, query, where, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { firebaseApp } from "../../system/firebase";
import { TopBar } from "../../_shared/TopBar";
import Lottie from "lottie-react";
import anim from "../../assets/anim/success.json";
import thumb from "../../assets/anim/thumb.json";

const RouteConferenceRegistration = () => {
    const [screen, setScreen] = useState(0);
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);
    const [event, setEvent] = useState(null);
    const [presenceType, setPresenceType] = useState("");
    const db = getFirestore(firebaseApp);

    // get id from url
    const id = window.location.pathname.split("/")[2];

    // fetch the event from Firestore
    useEffect(() => {
        if (!id) return;
        getDoc(doc(db, 'ALL_EVENTS', id)).then((snap) => {
            if (snap.exists()) {
                setEvent({ id: snap.id, ...snap.data() });
            }
        });
    }, []);

    const register = async () => {
        if (!email.trim() || !name.trim() || !presenceType.trim()) {
            alert("Please fill in your details");
            return;
        }
        setLoading(true);

        // Check if already registered
        const q = query(
            collection(db, 'ALL_SUBSCRIBERS'),
            where('eventId', '==', id),
            where('email', '==', email.toLowerCase().trim())
        );
        const existing = await getDocs(q);

        if (!existing.empty) {
            setScreen(3);
            setLoading(false);
            return;
        }

        // Register new subscriber
        await addDoc(collection(db, 'ALL_SUBSCRIBERS'), {
            name: name.trim(),
            email: email.toLowerCase().trim(),
            presenceType,
            eventId: id,
            eventName: event?.name || '',
            status: 'pending',
            time: serverTimestamp(),
        });

        setScreen(2);
        setLoading(false);
    };

    return (
        <div className="screen-webinars">
            <TopBar />
            {screen === 0 && <>
                <div className="webinar-rl">
                    <div className="box-root padding-bottom--24 flex-flex flex-justifyContent--center">
                        <h1 className="top-title"><a href="#" rel="dofollow">Conference Registration</a></h1>
                    </div>
                    <h2 style={{ textAlign: 'center', color: '#b87201' }}>{event?.name}</h2>
                    <p>Complete the form below to begin your registration</p>
                    <div className="formbg-outer">
                        <div className="formbg">
                            <div className="formbg-inner padding-horizontal--48">
                                <div id="stripe-login">
                                    <div className="field padding-bottom--24">
                                        <label htmlFor="email">Email Address</label>
                                        <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="field padding-bottom--24">
                                        <label htmlFor="name">Full Name</label>
                                        <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} />
                                    </div>
                                    <div className="field padding-bottom--24">
                                        <label htmlFor="presence">Attendance Type</label>
                                        <select name="presence" value={presenceType} onChange={(e) => setPresenceType(e.target.value)}>
                                            <option value="">-- Select --</option>
                                            <option value="in-person">In-Person</option>
                                            <option value="virtual">Virtual</option>
                                        </select>
                                    </div>
                                    <div className="field padding-bottom--24">
                                        <input onClick={register} type="submit" name="submit" value="Register" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-link padding-top--24">
                            <div className="listing padding-top--24 padding-bottom--24 flex-flex center-center">
                                <span><a href="/">© ABSK Africa</a></span>
                                <span><a href="/">Privacy &amp; terms</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                {loading && <div className="modal-bg">
                    <div className="">
                        <div className="lds-spinner spinner-orange" style={{ margin: 0 }}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <h3>saving your data</h3>
                    </div>
                </div>}
            </>}

            {screen === 2 && <>
                <div className="webinar-rl">
                    <div className="success-image">
                        <Lottie animationData={anim} />
                    </div>
                    <div className="box-root padding-bottom--24 flex-flex flex-justifyContent--center">
                        <h1 className="top-title"><a href="#" rel="dofollow">Successful!</a></h1>
                    </div>
                    <p className="iinfo">Check your email, we have sent you a link to finish the conference registration.</p>
                    <div className='action-bt'>
                        <a href="/">Back to Home</a>
                    </div>
                </div>
            </>}

            {screen === 3 && <>
                <div className="webinar-rl">
                    <div className="success-image">
                        <Lottie animationData={thumb} />
                    </div>
                    <div className="box-root padding-bottom--24 flex-flex flex-justifyContent--center">
                        <h1 className="top-title"><a href="#" rel="dofollow">Already Registered!</a></h1>
                    </div>
                    <p className="iinfo">You have already registered for this conference. Check your email for the payment link.</p>
                    <div className='action-bt'>
                        <a href="/">Back to Home</a>
                    </div>
                </div>
            </>}
        </div>
    );
};

export default RouteConferenceRegistration;